import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./supplychain.css";
import ServiceFooter from "../../ServiceFooter";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useState } from "react";
import { whyChooseData } from "./data";

const Supplychain = () => {
  // type
  const [isPrevTypeDisabled, setIsPrevTypeDisabled] = useState(true);
  const [isNextTypeDisabled, setIsNextTypeDisabled] = useState(false);

  const handleTypeChange = (TypeSwiper) => {
    setIsPrevTypeDisabled(TypeSwiper.isBeginning);
    setIsNextTypeDisabled(TypeSwiper.isEnd);
  };

  // key
  const [isPrevKeyDisabled, setIsPrevKeyDisabled] = useState(true);
  const [isNextKeyDisabled, setIsNextKeyDisabled] = useState(false);

  const handleKeyChange = (KeySwiper) => {
    setIsPrevKeyDisabled(KeySwiper.isBeginning);
    setIsNextKeyDisabled(KeySwiper.isEnd);
  };

  const [industries, setIndustries] = useState("retail");

  const handleIndustryChange = (tabId) => {
    setIndustries(tabId);
  };

  // why choose accordion
  const [accordionOpen, setAccordionOpen] = useState(null);

  const handleToggleAccordion = (index) => {
    setAccordionOpen((prevIndex) => (prevIndex === index ? null : index));
  };

  // how to choose
  const [isPrevHowDisabled, setIsPrevHowDisabled] = useState(true);
  const [isNextHowDisabled, setIsNextHowDisabled] = useState(false);

  const handleHowChange = (HowSwiper) => {
    setIsPrevHowDisabled(HowSwiper.isBeginning);
    setIsNextHowDisabled(HowSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Supply Chain Software Development Company</title>

        <meta
          name="title"
          content="Supply Chain Software Development Company"
        />
        <meta
          name="description"
          content="With our customized supply chain management software development, Your company can improve efficiency, reduce costs, and gain a competitive edge in the industry."
        />

        <meta
          property="og:title"
          content="Supply Chain Software Development Company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/supply-chain-software-development"
        />
      </Helmet>

      <main className="sc-main ">
        {/* hero */}
        <article className="sc-hero sc-mb-120">
          <div className="primary__landing__container">
            <h1 className="sc-hero-title">
              Supply Chain Software Development Company
            </h1>
            <p className="sc-hero-content">
              Optimize and manage your supply chain with beleaf cutting edge
              supply chain management solutions.
            </p>

            <div className="sc-hero-btn-wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn sc-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>

            <div className="text-center sc-hero-img">
              <img
                src={require("../../../image/supplychain/hero.webp")}
                alt="Supply Chain Software Development Company"
              />
            </div>
          </div>
        </article>

        {/* about */}
        <article className="sc-about primary__landing__container sc-mb-80">
          <div className="row mx-0 sc-about-row">
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/supplychain/about.webp")}
                alt="Supply Chain Software Development Company"
              />
            </div>
            <div className="col-lg-6">
              <h3 className="sc-subtitle sc-abt-title">
                What is a Supply Chain Software Development Company?
              </h3>

              <div className="sc-abt-wrap">
                <div className="sc-ab-check-wrap">
                  <i className="fa-solid fa-check"></i>
                </div>
                <p className="sc-ab-check-content">
                  A supply chain software development company specializes in
                  creating customized software solutions that help businesses
                  manage and optimize their supply chain processes.
                </p>
              </div>
              <div className="sc-abt-wrap">
                <div className="sc-ab-check-wrap">
                  <i className="fa-solid fa-check"></i>
                </div>
                <p className="sc-ab-check-content">
                  These companies develop solutions for Inventory management,
                  Warehouse management, Transportation management, Order
                  processing, Demand forecasting, Supplier relationship
                  management.
                </p>
              </div>
              <div className="sc-abt-wrap sc-mb-32">
                <div className="sc-ab-check-wrap">
                  <i className="fa-solid fa-check"></i>
                </div>
                <p className="sc-ab-check-content">
                  A reliable supply chain software development company ensures
                  that businesses can track shipments in real-time, automate
                  operations, and improve overall productivity with seamless
                  digital solutions.
                </p>
              </div>

              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn sc-btn "
              >
                <div className="re-btn-txt">Get Free Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* types */}
        <article className="sc-types sc-linear-divider sc-mb-80">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle-two sc-type-title">
              Types of Supply Chain Software Development
            </h3>

            <div>
              <Swiper
                className="fd-step-swiper az-dev-swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".sc-type-prev-arr",
                  nextEl: ".sc-type-next-arr",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleTypeChange}
                onReachBeginning={() => setIsPrevTypeDisabled(true)}
                onReachEnd={() => setIsNextTypeDisabled(true)}
                onFromEdge={() => {
                  setIsPrevTypeDisabled(false);
                  setIsNextTypeDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-one.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Enterprise Resource Planning Systems</h5>
                      <p>
                        These integrate multiple functions (finance, HR, supply
                        chain) within an organization.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-two.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Transportation Management Systems</h5>
                      <p>
                        Focuses on the planning, execution, and optimization of
                        the transportation of goods.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-three.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Warehouse Management Systems</h5>
                      <p>
                        Manages the movement and storage of inventory in
                        warehouses.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-four.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Inventory Management Systems</h5>
                      <p>
                        Specialized systems to track and control inventory in
                        real-time.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-five.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Supply Chain Visibility Platforms</h5>
                      <p>
                        Provide end-to-end visibility to monitor the flow of
                        goods and data across the entire supply chain.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-type-card">
                    <div className="text-center">
                      <img
                        src={require("../../../image/supplychain/type-img-six.webp")}
                        alt="Supply Chain Software Development Company"
                        className="w-100"
                      />
                    </div>

                    <div className="sc-type-content-wrap">
                      <h5>Customer Relationship Management Systems</h5>
                      <p>
                        Often integrated with supply chain solutions to manage
                        customer interactions and order processing.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`sc-type-prev-arr ${
                    isPrevTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevTypeDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isPrevTypeDisabled ? "not-allowed" : "pointer",
                    background: isPrevTypeDisabled
                      ? "transparent"
                      : "transparent",
                    border: isPrevTypeDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`sc-type-next-arr ${
                    isNextTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextTypeDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isNextTypeDisabled ? "not-allowed" : "pointer",
                    background: isNextTypeDisabled
                      ? "transparent"
                      : "transparent",
                    border: isNextTypeDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="sc-benefits sc-linear-divider sc-mb-120">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle-two sc-ben-title">
              Benefits of Supply Chain Management Software Development
            </h3>

            <p className="sc-subcontent sc-ben-content">
              Choosing supply chain management software development brings
              several advantages for businesses, including
            </p>

            <div className="row mx-0 sc-ben-row g-4 mt-4">
              <div className="col-lg-6 col-md-6">
                <div className="sc-ben-card">
                  <img
                    src={require("../../../image/supplychain/ben-img-one.webp")}
                    alt="Supply Chain Software Development Company"
                    className="w-100"
                  />

                  <div className="sc-ben-content-wrap">
                    <h5>Increased Efficiency</h5>
                    <p>
                      Automation of logistics and inventory management improves
                      operational efficiency, reduces manual errors, and speeds
                      up processes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="sc-ben-card">
                  <img
                    src={require("../../../image/supplychain/ben-img-two.webp")}
                    alt="Supply Chain Software Development Company"
                    className="w-100"
                  />

                  <div className="sc-ben-content-wrap">
                    <h5>Cost Reduction</h5>
                    <p>
                      A well-optimized supply chain minimizes unnecessary
                      expenses by improving inventory management, demand
                      forecasting, and warehouse utilization.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="sc-ben-card">
                  <img
                    src={require("../../../image/supplychain/ben-img-three.webp")}
                    alt="Supply Chain Software Development Company"
                    className="w-100"
                  />

                  <div className="sc-ben-content-wrap">
                    <h5>Real Time Visibility</h5>
                    <p>
                      With supply chain software development company solutions,
                      businesses gain real-time insights into shipments,
                      inventory levels, and supplier interactions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="sc-ben-card">
                  <img
                    src={require("../../../image/supplychain/ben-img-four.webp")}
                    alt="Supply Chain Software Development Company"
                    className="w-100"
                  />

                  <div className="sc-ben-content-wrap">
                    <h5>Enhanced Decision Making</h5>
                    <p>
                      Advanced analytics in supply chain management software
                      development enables data-driven decisions, helping
                      businesses plan better and optimize operations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="sc-ben-card">
                  <img
                    src={require("../../../image/supplychain/ben-img-five.webp")}
                    alt="Supply Chain Software Development Company"
                    className="w-100"
                  />

                  <div className="sc-ben-content-wrap">
                    <h5>Improved Supplier and Customer Relationships</h5>
                    <p>
                      A seamless supply chain leads to faster deliveries, better
                      supplier collaboration, and enhanced customer
                      satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* key features */}
        <article className="sc-key sc-linear-divider ">
          <div className="primary__landing__container">
            <h3 className="sc-subtitle sc-key-title">
              Key Features of Supply Chain Management Software Development
            </h3>
            <p className="sc-key-content">
              A supply chain software development company integrates essential
              features to ensure smooth logistics operations. Some of the core
              functionalities include
            </p>

            <div>
              <Swiper
                className="fd-step-swiper az-dev-swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".sc-key-prev-arr",
                  nextEl: ".sc-key-next-arr",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleKeyChange}
                onReachBeginning={() => setIsPrevKeyDisabled(true)}
                onReachEnd={() => setIsNextKeyDisabled(true)}
                onFromEdge={() => {
                  setIsPrevKeyDisabled(false);
                  setIsNextKeyDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-one.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Inventory Management </h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Inventory Management </h4>
                      <p>
                        Track stock levels, manage reordering, and prevent
                        overstocking or stockouts using automated inventory
                        management tools.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-two.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Warehouse Management </h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Warehouse Management </h4>
                      <p>
                        Enhance warehouse efficiency with automated picking,
                        packing, and shipping workflows for streamlined
                        fulfillment.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-three.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Order Management </h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Order Management </h4>
                      <p>
                        Track orders from placement to delivery, ensuring timely
                        fulfillment and accurate order processing.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-four.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Logistics and Transportation Management</h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Logistics and Transportation Management</h4>
                      <p>
                        Optimize delivery routes, track shipments in real-time,
                        and automate transportation planning for cost-effective
                        logistics.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-five.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Demand Forecasting </h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Demand Forecasting </h4>
                      <p>
                        Use AI and machine learning algorithms to predict demand
                        patterns and optimize inventory planning.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-six.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Supplier Relationship Management</h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Supplier Relationship Management</h4>
                      <p>
                        Maintain seamless communication with suppliers, track
                        contracts, and ensure timely procurement of goods.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-key-card">
                    <div className="sc-key-card-one">
                      <img
                        src={require("../../../image/supplychain/key-img-seven.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4>Analytics and Reporting</h4>

                      <img
                        src={require("../../../image/supplychain/key-rgt.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-rgt"
                      />
                      <img
                        src={require("../../../image/supplychain/key-lft.webp")}
                        alt="Supply Chain Software Development Company"
                        className="sc-key-lft"
                      />
                    </div>
                    <div className="sc-key-card-two">
                      <h4>Analytics and Reporting</h4>
                      <p>
                        Gain actionable insights through advanced analytics, KPI
                        tracking, and custom reporting dashboards.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`sc-key-prev-arr ${
                    isPrevKeyDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevKeyDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isPrevKeyDisabled ? "not-allowed" : "pointer",
                    background: isPrevKeyDisabled
                      ? "transparent"
                      : "transparent",
                    border: isPrevKeyDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`sc-key-next-arr ${
                    isNextKeyDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextKeyDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isNextKeyDisabled ? "not-allowed" : "pointer",
                    background: isNextKeyDisabled
                      ? "transparent"
                      : "transparent",
                    border: isNextKeyDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* industries */}
        <article className="sc-industry sc-linear-divider">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle-two sc-ind-title">
              Industries That Need Supply Chain Management Software Development
            </h3>
            <p className="sc-subcontent sc-ind-content ">
              A supply chain software development company serves multiple
              industries, including
            </p>

            <div className="row mx-0 sc-ind-row">
              <div className="col-md-6 p-0">
                <div className="sc-ind-left">
                  <div
                    className={`sc-ind-top ${
                      industries === "retail" ? "active" : ""
                    }`}
                    onClick={() => handleIndustryChange("retail")}
                  >
                    <div className="sc-ind-content-wrap">
                      <img
                        src={require("../../../image/supplychain/ind-img-one.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4 className="sc-ind-lft-title">
                        Retail and Ecommerce
                      </h4>
                    </div>
                    <span
                      className={`sc-ind-lft-arr ${
                        industries === "retail" ? "d-block" : "d-none"
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>

                  <div
                    className={`sc-ind-top ${
                      industries === "manufacturing" ? "active" : ""
                    }`}
                    onClick={() => handleIndustryChange("manufacturing")}
                  >
                    <div className="sc-ind-content-wrap">
                      <img
                        src={require("../../../image/supplychain/ind-img-two.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4 className="sc-ind-lft-title">Manufacturing</h4>
                    </div>
                    <span
                      className={`sc-ind-lft-arr ${
                        industries === "manufacturing" ? "d-block" : "d-none"
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>

                  <div
                    className={`sc-ind-top ${
                      industries === "healthcare" ? "active" : ""
                    }`}
                    onClick={() => handleIndustryChange("healthcare")}
                  >
                    <div className="sc-ind-content-wrap">
                      <img
                        src={require("../../../image/supplychain/ind-img-three.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4 className="sc-ind-lft-title">Healthcare</h4>
                    </div>
                    <span
                      className={`sc-ind-lft-arr ${
                        industries === "healthcare" ? "d-block" : "d-none"
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>

                  <div
                    className={`sc-ind-top ${
                      industries === "logistics" ? "active" : ""
                    }`}
                    onClick={() => handleIndustryChange("logistics")}
                  >
                    <div className="sc-ind-content-wrap">
                      <img
                        src={require("../../../image/supplychain/ind-img-four.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4 className="sc-ind-lft-title">
                        Logistics and Transportation
                      </h4>
                    </div>
                    <span
                      className={`sc-ind-lft-arr ${
                        industries === "logistics" ? "d-block" : "d-none"
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>

                  <div
                    className={`sc-ind-top ${
                      industries === "food" ? "active" : ""
                    }`}
                    onClick={() => handleIndustryChange("food")}
                  >
                    <div className="sc-ind-content-wrap">
                      <img
                        src={require("../../../image/supplychain/ind-img-five.webp")}
                        alt="Supply Chain Software Development Company"
                      />
                      <h4 className="sc-ind-lft-title">Food and Beverage</h4>
                    </div>
                    <span
                      className={`sc-ind-lft-arr ${
                        industries === "food" ? "d-block" : "d-none"
                      }`}
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div
                  className={`sc-ind-rgt ${
                    industries === "retail" ? "bg-two" : ""
                  }`}
                >
                  <p>
                    Retailers need real-time inventory tracking, order
                    management, and demand forecasting to stay competitive.
                  </p>
                </div>
                <div
                  className={`sc-ind-rgt ${
                    industries === "manufacturing" ? "bg-one" : ""
                  }`}
                >
                  <p>
                    Manufacturers benefit from automated inventory control,
                    supplier management, and logistics optimization.
                  </p>
                </div>
                <div
                  className={`sc-ind-rgt ${
                    industries === "healthcare" ? "bg-three" : ""
                  }`}
                >
                  <p>
                    Pharmaceutical companies and healthcare providers require
                    supply chain solutions for inventory tracking, regulatory
                    compliance, and logistics management.
                  </p>
                </div>
                <div
                  className={`sc-ind-rgt ${
                    industries === "logistics" ? "bg-four" : ""
                  }`}
                >
                  <p>
                    Logistics companies use supply chain management software
                    development to optimize fleet management and shipment
                    tracking.
                  </p>
                </div>
                <div
                  className={`sc-ind-rgt ${
                    industries === "food" ? "bg-five" : ""
                  }`}
                >
                  <p>
                    Food companies use supply chain software to ensure timely
                    deliveries, manage perishable inventory, and maintain
                    quality control.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* blockchain */}
        <article className="sc-blockchain sc-linear-divider">
          <div className="sc-blockchain-inner primary__landing-content-container">
            <h3 className="sc-subtitle-two sc-bl-title">
              Blockchain in Supply Chain Software Development
            </h3>
            <p className="sc-subcontent sc-bl-content">
              Blockchain technology provides transparency, security, and
              traceability, enhancing supply chain efficiency. Some benefits of
              blockchain in supply chain management software development include
            </p>
            <div className="sc-hero-btn-wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn sc-btn"
              >
                <div className="re-btn-txt">Contact to know more</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>

            <div className="row mx-0 sc-bl-row g-3 g-xl-4">
              <div className="col-lg-3 col-md-6">
                <div className="sc-bl-card-outer">
                  <div className="sc-bl-card-inner">
                    <img
                      src={require("../../../image/supplychain/bl-img-one.webp")}
                      alt="Supply Chain Software Development Company"
                    />
                    <h6>Enhanced Transparency</h6>
                    <p>
                      Blockchain creates an immutable ledger, ensuring every
                      transaction is recorded and visible to all stakeholders.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="sc-bl-card-outer">
                  <div className="sc-bl-card-inner">
                    <img
                      src={require("../../../image/supplychain/bl-img-two.webp")}
                      alt="Supply Chain Software Development Company"
                    />
                    <h6>Improved Security</h6>
                    <p>
                      Data encryption and decentralized storage reduce the risk
                      of fraud and cyber threats.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="sc-bl-card-outer">
                  <div className="sc-bl-card-inner">
                    <img
                      src={require("../../../image/supplychain/bl-img-three.webp")}
                      alt="Supply Chain Software Development Company"
                    />
                    <h6>Efficient Smart Contracts</h6>
                    <p>
                      Automated contracts streamline supplier agreements and
                      order processing.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="sc-bl-card-outer">
                  <div className="sc-bl-card-inner">
                    <img
                      src={require("../../../image/supplychain/bl-img-four.webp")}
                      alt="Supply Chain Software Development Company"
                    />
                    <h6>Real Time Tracking</h6>
                    <p>
                      Businesses can track shipments in real time, ensuring
                      accurate and on-time deliveries.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <img
              src={require("../../../image/supplychain/bl-bg.webp")}
              alt="Supply Chain Software Development Company"
              className="sc-bl-bg"
            />
          </div>
        </article>

        {/* ai */}
        <article className="sc-ai sc-linear-divider">
          <div className="primary__landing-content-container">
            <div className="row mx-0 sc-ai-row">
              <div className="col-lg-6">
                <h3 className="sc-ai-title">
                  AI in Supply Chain Software Development
                </h3>
                <p className="sc-ai-content">
                  Artificial Intelligence (AI) enhances supply chain operations
                  through automation, predictive analytics, and intelligent
                  decision-making. Some applications of AI in supply chain
                  management software development include
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="primary-landing-main-btn re-hero-btn sc-btn"
                >
                  <div className="re-btn-txt">Get Consultation</div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
              <div className="col-lg-6 sc-ai-rgt">
                <div className="sc-ai-card">
                  <img
                    src={require("../../../image/supplychain/ai-img-one.webp")}
                    alt="Supply Chain Software Development Company"
                  />
                  <h5>Predictive Analytics</h5>
                  <p>
                    AI forecasts demand and optimizes inventory management to
                    prevent stockouts and overstocking.
                  </p>
                </div>
                <div className="sc-ai-card">
                  <img
                    src={require("../../../image/supplychain/ai-img-two.webp")}
                    alt="Supply Chain Software Development Company"
                  />
                  <h5>Automated Decision Making</h5>
                  <p>
                    AI-powered algorithms optimize transportation routes and
                    warehouse operations.
                  </p>
                </div>
                <div className="sc-ai-card">
                  <img
                    src={require("../../../image/supplychain/ai-img-three.webp")}
                    alt="Supply Chain Software Development Company"
                  />
                  <h5>Chatbots and Virtual Assistants</h5>
                  <p>
                    AI-driven chatbots improve customer support and supplier
                    communications.
                  </p>
                </div>
                <div className="sc-ai-card">
                  <img
                    src={require("../../../image/supplychain/ai-img-four.webp")}
                    alt="Supply Chain Software Development Company"
                  />
                  <h5>Fraud Detection</h5>
                  <p>
                    AI analyzes transactions to identify and prevent fraudulent
                    activities.
                  </p>
                </div>
                <div className="sc-ai-card">
                  <img
                    src={require("../../../image/supplychain/ai-img-five.webp")}
                    alt="Supply Chain Software Development Company"
                  />
                  <h5>Process Automation</h5>
                  <p>
                    AI-powered robotic process automation (RPA) eliminates
                    manual tasks, reducing errors and improving efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="sc-why-choose sc-linear-divider">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle sc-why-choose-title">
              Why Choose a Custom Supply Chain Software Development Company?
            </h3>
            <p className="sc-subcontent sc-why-choose-content">
              While off-the-shelf solutions exist, partnering with a supply
              chain software development company for a custom solution offers
              several advantages
            </p>

            <div className="row mx-0 g-4 sc-why-choose-row">
              {whyChooseData.map((data, index) => {
                return (
                  <div key={data.id} className="col-md-6">
                    <div
                      // className={`sc-why-choose-card `}
                      className={`sc-why-choose-card ${
                        accordionOpen === index ? "sc-wy-h" : ""
                      }`}
                    >
                      <div className="sc-why-choose-inner-card">
                        <div
                          className={`sc-why-choose-top`}
                          onClick={() => handleToggleAccordion(index)}
                        >
                          <di
                            className={`sc-wy-top-outer ${
                              accordionOpen === index ? "sc-wy-bb" : ""
                            }`}
                          >
                            <div className="d-flex align-items-center gap-3">
                              <img
                                src={data.img}
                                alt="Supply Chain Software Development Company"
                              />
                              <h5 className="sc-wy-card-title">{data.title}</h5>
                            </div>
                            <span className="sc-why-card-arr">
                              <i className="fa-solid fa-plus"></i>
                            </span>
                          </di>
                        </div>

                        {accordionOpen === index && (
                          <div
                            // className={`sc-why-choose-main ${
                            //   accordionOpen === index ? "show" : ""
                            // }`}
                            className={`sc-why-choose-main`}
                          >
                            <p>{data.content}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </article>

        {/* emerging */}
        <article className="sc-emerging sc-linear-divider">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle sc-why-choose-title">
              Emerging Trends in Supply Chain Management Software Development
            </h3>
            <p className="sc-subcontent sc-why-choose-content">
              A leading supply chain software development company integrates the
              latest trends to improve efficiency and innovation.
            </p>

            <div className="row mx-0 g-4 sc-emerging-row">
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="sc-em-card em-one">
                  <div className="sc-em-card-bottom">
                    <h4>Artificial Intelligence and Machine Learning</h4>
                    <p>
                      AI-driven analytics help businesses predict demand,
                      optimize routes, and enhance decision-making.
                    </p>
                  </div>

                  <div className="sc-em-card-top">
                    <h6>Artificial Intelligence and Machine Learning</h6>
                    <span>
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="sc-em-card em-two">
                  <div className="sc-em-card-bottom">
                    <h4> Blockchain Technology</h4>
                    <p>
                      Blockchain ensures traceability, security, transparency,
                      in supply chain operations.
                    </p>
                  </div>

                  <div className="sc-em-card-top">
                    <h6>Blockchain Technology</h6>
                    <span>
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="sc-em-card em-three">
                  <div className="sc-em-card-bottom">
                    <h4>Robotic Process Automation (RPA)</h4>
                    <p>
                      Automation of repetitive tasks like data entry and order
                      processing improves efficiency.
                    </p>
                  </div>

                  <div className="sc-em-card-top">
                    <h6>Robotic Process Automation (RPA)</h6>
                    <span>
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="sc-em-card em-four">
                  <div className="sc-em-card-bottom">
                    <h4>Cloud-Based Solutions</h4>
                    <p>
                      Cloud-based supply chain management software development
                      allows businesses to access real-time data from anywhere.
                    </p>
                  </div>

                  <div className="sc-em-card-top">
                    <h6>Cloud-Based Solutions</h6>
                    <span>
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* how to choose */}
        <article className="sc-how-choose sc-linear-divider">
          <div className="primary__landing-content-container">
            <h3 className="sc-subtitle sc-why-choose-title">
              How to Choose the Best Supply Chain Software Development Company?
            </h3>
            <p className="sc-subcontent text-center">
              To find the right supply chain software development company,
              consider the following factors
            </p>

            <div className="row">
              <div className="col-lg-4"></div>
            </div>

            <div>
              <Swiper
                className="fd-step-swiper az-dev-swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".sc-hw-prev-arr",
                  nextEl: ".sc-hw-next-arr",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleHowChange}
                onReachBeginning={() => setIsPrevHowDisabled(true)}
                onReachEnd={() => setIsNextHowDisabled(true)}
                onFromEdge={() => {
                  setIsPrevHowDisabled(false);
                  setIsNextHowDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="sc-hw-card">
                    <img
                      src={require("../../../image/supplychain/hw-img-one.webp")}
                      alt="Supply Chain Software Development Company"
                    />

                    <div className="sc-hw-content-wrap">
                      <h5>Experience and Expertise</h5>
                      <p>
                        Look for companies with a proven track record in supply
                        chain management software development.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-hw-card">
                    <img
                      src={require("../../../image/supplychain/hw-img-two.webp")}
                      alt="Supply Chain Software Development Company"
                    />

                    <div className="sc-hw-content-wrap">
                      <h5>Customization Capabilities</h5>
                      <p>
                        Ensure the company can build custom solutions tailored
                        to your business needs.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-hw-card">
                    <img
                      src={require("../../../image/supplychain/hw-img-three.webp")}
                      alt="Supply Chain Software Development Company"
                    />

                    <div className="sc-hw-content-wrap">
                      <h5>Technology Stack</h5>
                      <p>
                        Check if the company uses advanced technologies like AI,
                        IoT, and blockchain.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-hw-card">
                    <img
                      src={require("../../../image/supplychain/hw-img-four.webp")}
                      alt="Supply Chain Software Development Company"
                    />

                    <div className="sc-hw-content-wrap">
                      <h5>Client Reviews and Testimonials</h5>
                      <p>
                        Research customer feedback and case studies to assess
                        the company’s reliability.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="sc-hw-card">
                    <img
                      src={require("../../../image/supplychain/hw-img-five.webp")}
                      alt="Supply Chain Software Development Company"
                    />

                    <div className="sc-hw-content-wrap">
                      <h5>Support and Maintenance</h5>
                      <p>
                        Choose a supply chain software development company that
                        offers ongoing support and updates.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`sc-hw-prev-arr ${
                    isPrevHowDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevHowDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isPrevHowDisabled ? "not-allowed" : "pointer",
                    background: isPrevHowDisabled
                      ? "transparent"
                      : "transparent",
                    border: isPrevHowDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`sc-hw-next-arr ${
                    isNextHowDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextHowDisabled ? "#ffffff90" : "#ffffff",
                    cursor: isNextHowDisabled ? "not-allowed" : "pointer",
                    background: isNextHowDisabled
                      ? "transparent"
                      : "transparent",
                    border: isNextHowDisabled
                      ? "1px solid #1F1E24"
                      : "1px solid #fff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta sc-linear-divider">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              A supply chain software development company plays a critical role
              in optimizing logistics and improving business efficiency. With
              customized supply chain management software development,
              businesses can streamline operations, enhance decision-making, and
              gain a competitive edge. Investing in the right supply chain
              management software development can transform your business and
              drive long-term success.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How does supply chain software improve efficiency?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          It automates manual tasks, streamlines workflows, and
                          provides real-time insights, reducing errors and
                          speeding up decision-making. This leads to more
                          efficient operations.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can supply chain software integrate with existing
                          systems?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, most supply chain software can integrate with
                          ERP, CRM, and other enterprise systems, ensuring
                          seamless data flow and operation coordination.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What technologies are used in supply chain software
                          development?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Key technologies include cloud computing, AI/ML for
                          predictive analytics, IoT for real-time tracking, and
                          blockchain for enhanced transparency and security.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Is supply chain software customizable?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, supply chain software can be customized to meet
                          specific business needs, from inventory management to
                          supplier collaboration, ensuring it aligns with
                          company goals.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Supplychain;
